import ChangePassword from '../components/change-password'
import DisabledAccount from '../components/disabled-account/disabled-account'

export default {
  ChangePassword,
  DisabledAccount
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/resources/components.js